import * as HttpMethods from 'utils/constants/method';

export const apiRoutes = {
    // Get Static Props APIs

    // Before Login APIs
    csrf: { apiPath: '/sanctum/csrf-cookie', action: HttpMethods.GET },
    login: { apiPath: '/api/login', action: HttpMethods.POST },
    register: { apiPath: '/api/register', action: HttpMethods.POST },

    //Events
    addEvent: { apiPath: '/api/v2/events', action: HttpMethods.POST },
    updateEvent: { apiPath: '/api/v2/events/:eventId/update', action: HttpMethods.POST },
    showEvent: { apiPath: '/api/v2/events', action: HttpMethods.GET },
    deleteEvent: { apiPath: '/api/v2/events/:eventId', action: HttpMethods.DELETE },
    showSingleEvent: { apiPath: '/api/v2/events/:eventId', action: HttpMethods.GET },
    sendCertificate: { apiPath: '/api/v2/send_certificate/:eventId', action: HttpMethods.POST },

    // Students
    showSingleStudent: { apiPath: '/api/v2/student_register/:studentId', action: HttpMethods.GET },
    getStudents: { apiPath: '/api/v2/student_register', action: HttpMethods.GET },
    addStudent: { apiPath: '/api/v2/student_register', action: HttpMethods.POST },
    updateStudent: { apiPath: '/api/v2/student_register/:studentId', action: HttpMethods.PUT },

    //Testimonial
    addTestimonial: { apiPath: '/api/v2/testimonials', action: HttpMethods.POST },
    getTestimonial: { apiPath: '/api/v2/testimonials', action: HttpMethods.GET },
    updateTestimonial: { apiPath: '/api/v2/testimonials/:testimonialId/update', action: HttpMethods.POST },
    deleteTestimonial: { apiPath: '/api/v2/testimonials/:testimonialId', action: HttpMethods.DELETE },

    //Courses
    addCourse: { apiPath: '/api/v2/courses', action: HttpMethods.POST },
    getCourse: { apiPath: '/api/v2/courses', action: HttpMethods.GET },
    updateCourse: { apiPath: '/api/v2/courses/:courseId/update', action: HttpMethods.POST },
    deleteCourse: { apiPath: '/api/v2/courses/:courseId', action: HttpMethods.DELETE },

    //Product
    addProduct: { apiPath: '/api/v2/products', action: HttpMethods.POST },
    getProduct: { apiPath: '/api/v2/products', action: HttpMethods.GET },
    updateProduct: { apiPath: '/api/v2/products/:productId/update', action: HttpMethods.POST },
    deleteProduct: { apiPath: '/api/v2/products/:productId', action: HttpMethods.DELETE },

    addMedia: { apiPath: '/api/media', action: HttpMethods.POST },

    checkDate: {
        apiPath: 'https://sabarimalaonline.org/api/eDarshan/darshanAvailability/2022-1-5/100001',
        action: HttpMethods.POST,
    },
    addWishList: {
        apiPath: 'https://sabarimalaonline.org/api/tofcart/addToWishlist',
        action: HttpMethods.POST,
    },
};
